import React, { useRef, useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';

const TrialWidget = (props) => {
    let imgPath = props.app.config.assetsUrl + "/" + props.app.config.imageUrl;

    const [ showWidget, setShowWidget ] = useState(true);
    const [ transition, setTransition ] = useState({
        duration: 0.8,
        delay: 1
    });

    const closeWidget = () => {
        window.sessionStorage.setItem('showWidget', false);
        setShowWidget(false);
    }

    const claimDeal = () => {
        props.router.navigate('/account/subscription/new?code=intrial50')
    }


    return (
        <AnimatePresence>
            {showWidget ? 
                (<motion.div 
                    className="trial-widget" 
                    transition={transition}
                    initial={{
                        opacity: 0,
                        right: '40px'
                    }}
                    animate={{
                        opacity: 1,
                        right: '10px'
                    }}
                    exit={{
                        opacity: 0
                    }}
                    onAnimationComplete={() => {
                        if (showWidget) {
                            setTransition({
                                duration: 0.8,
                                delay: 0
                            })
                        }
                    }}>
                    <div className="close-button" role="button" aria-label="Close Offer" onClick={closeWidget}>
                        <i className="fa fa-times"/>
                    </div>
                    <div className="widget-icon">
                        <img src={`${imgPath}/misc/sale-img.svg`}/>
                    </div>
                    <div className="widget-headline">
                        Save 50%
                    </div>
                    <div className="widget-detail">
                        Get 50% off your first month<br/>
                        Offer expires at end of trial
                    </div>
                    <div className="widget-cta">
                        <div className="widget-button" role="button" aria-label='Claim This Deal' onClick={claimDeal}>
                            Get Best Price
                        </div>
                    </div>
                </motion.div>) : null}
        </AnimatePresence>
    )
};

export default TrialWidget;